import { useState, useContext, useEffect } from "react";
import { FaCalculator, FaEdit, FaGlobe, FaIdBadge, FaMale, FaSync, FaUser, FaCalendarAlt, FaHeart, FaFemale, FaBaby } from "react-icons/fa";
import Button from "components/ui/controls/button/button";
import CardBox from "components/ui/controls/card-box/card-box";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import Modal from "components/ui/modal/modal";
import { AppContext } from "components/app/RemExprertProvider";
import CheckBox from "components/ui/controls/check-box/check-box";
import TextField from "components/ui/controls/text-field/text-field";
import { applyFormat } from "components/ui/ui-helpers";
import { CalculPartFiscale } from "components/app/Api/Remuneration/ApiRemuneration";
import ClientPageModal from "pages/extranet/client/client pager";
import DropDown from "components/ui/controls/drop-down/drop-down";
import Dialogs from "components/ui/dialogs/dialogs";
import { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import {
  createStyledButton,
} from "components/ui/controls/button/button-styles";

const DossierPage = (props) => {
  const context = useContext(AppContext);
  const [modalOpen, setmodalOpen] = useState(false);

  // Fonction pour obtenir l'icône selon la civilité
  const getCiviliteIcon = (civilite) => {
    const lowerCiv = civilite?.toLowerCase() || "";
    if (lowerCiv.includes("mme") || lowerCiv.includes("madame")) {
      return <FaFemale style={{ fontSize: "18px", color: "#ec4899" }} />;
    } else if (lowerCiv.includes("mr") || lowerCiv.includes("monsieur")) {
      return <FaMale style={{ fontSize: "18px", color: "#3b82f6" }} />;
    }
    return <FaUser style={{ fontSize: "18px", color: "#6b7280" }} />;
  };

  // Fonction pour obtenir le style du fond de l'icône selon la civilité
  const getCiviliteIconBackground = (civilite) => {
    const lowerCiv = civilite?.toLowerCase() || "";
    if (lowerCiv.includes("mme") || lowerCiv.includes("madame")) {
      return "#fdf2f8"; // Rose pour Madame
    } else if (lowerCiv.includes("mr") || lowerCiv.includes("monsieur")) {
      return "#dbeafe"; // Bleu pour Monsieur
    }
    return "#f3f4f6"; // Gris par défaut
  };


  const handleNe = (civilite) => {
    if (civilite === "Monsieur") {
      return "né";
    } else {
      return "née";
    }
  };
  const handleSituationMaritale = (Civilite, SituationMaritale) => {
    switch (SituationMaritale) {
      case "marie":
        return Civilite === "Monsieur" ? "marié" : "mariée";
      case "pacse":
        return Civilite === "Monsieur" ? "pacsé" : "pacsée";
      case "divorce":
        return Civilite === "Monsieur" ? "divorcé" : "divorcée";
      case "veuf":
        return Civilite === "Monsieur" ? "veuf" : "veuve";

      default:
        return "célibataire";
    }
  };

  useEffect(() => {
    if (context.state.SetPartFiscale === false) {
      CalculPartFiscale(context.state).then((PartFiscale) => {
        context.handleValueChange("PartFiscale", PartFiscale);
      });
    }
    if (context.state.TypeSimulation === "Audit complet" || context.state.TypeSimulation === "Audit retraite") {
      context.GetDateDepartRetraite("", context.state);
      context.CalculMajorationEnfant(context.state.Civilite, context.state.Enfant, context.state.Carriere, context.state.TableauEnfant, "", [
        context.state.CarriereMajorationEnfantSaisi,
        context.state.CarriereMajorationEnfantSaisiFonctionPublique,
        context.state.TrimestreBonificationEnfantSaisiFonctionPublique,
        context.state.CarriereMajorationEnfantSaisiCrpcen,
        context.state.CarriereMajorationEnfantSaisiCrpcenApres2006,
      ]);
      context.GetDateDepartRetraite("Conjoint", context.state);
      context.CalculMajorationEnfant(context.state.CiviliteConjoint, context.state.Enfant, context.state.CarriereConjoint, context.state.TableauEnfant, "Conjoint", [
        context.state.CarriereMajorationEnfantSaisiConjoint,
        context.state.CarriereMajorationEnfantSaisiFonctionPubliqueConjoint,
        context.state.TrimestreBonificationEnfantSaisiFonctionPubliqueConjoint,
        context.state.CarriereMajorationEnfantSaisiCrpcenConjoint,
        context.state.CarriereMajorationEnfantSaisiCrpcenApres2006Conjoint,
      ]);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context.state.SetPartFiscale, modalOpen,JSON.stringify(context.state.TableauEnfant),context.state.StatutMarital]);

  return (
    <>
      <Column fill>
        <Row>
          <Column fill>
            <CardBox fill>
              <Column fill>
                <Row>
                  <CardBoxHeader icon={<FaIdBadge />}>Paramètres du dossier</CardBoxHeader>
                </Row>
                <Row tpad>
                  <TextField style={{minWidth:'400px'}} label={"Titre de l'audit pour " + context.state.Prenom} value={context.state.LibelleDossier} onChange={context.handleInputChange("LibelleDossier")} />
                </Row>
                {(context.state.StatutMarital === "marie" || context.state.StatutMarital === "pacse") &&
                  (context.state.TypeSimulation === "Audit complet" || context.state.TypeSimulation === "Audit retraite") && (
                    <Row tpad>
                      <CheckBox
                        label={"Etudier également la situation pour " + context.state.PrenomConjoint}
                        before
                        inline
                        checked={true}
                        unchecked={false}
                        value={context.state.InclureConjoint}
                        // onChange={context.handleInclureConjoint}
                        onChange={(e) =>
                          e.target.checked === false ? (
                            Dialogs.confirm(
                              "Attention, la suppression du conjoint entraine également la suppression de l'ensemble des données saisies de l'individu et par voie de conséquence des études d'optimisation réalisées.",
                              "Suppression du conjoint",
                              () => {
                                context.handleInclureConjoint(false);
                              },
                              () => {
                                context.handleInclureConjoint(true);
                              }
                            )
                          ) : (
                            <>{context.handleInclureConjoint(e.target.checked)}</>
                          )
                        }
                      />
                    </Row>
                  )}
                {(context.state.StatutMarital === "marie" || context.state.StatutMarital === "pacse") &&
                  (context.state.TypeSimulation === "Audit rémunération" || context.state.TypeSimulation === "Audit prévoyance" ) && (
                    <Row tpad>
                      <DropDown
                        value={context.state.SwitchClient}
                        onChange={context.handleSwitchClient}
                        label="Etude réalisée pour"
                        options={[
                          { value: "client", label: context.state.SwitchPrenom },
                          { value: "conjoint", label: context.state.SwitchPrenomConjoint },
                        ]}
                        xlarge
                      />
                    </Row>
                  )}
              </Column>
            </CardBox>
          </Column>
          <Column fill>
            <CardBox lpad fill>
              <Column fill>
                <Row>
                  <CardBoxHeader icon={<FaUser />}>Récapitulatif du client</CardBoxHeader>
                </Row>
                
                {/* Client principal */}
                <Row tpad>
                  <div style={{
                    backgroundColor: "white",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    padding: "16px",
                    width: "100%",
                    marginBottom: "12px",
                    minHeight: "96px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)"
                  }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
                        <div style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          backgroundColor: getCiviliteIconBackground(
                            (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "client" 
                              ? context.state.SwitchCivilite 
                              : (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "conjoint"
                                ? context.state.SwitchCiviliteConjoint
                                : context.state.Civilite
                          ),
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginRight: "16px"
                        }}>
                          {getCiviliteIcon(
                            (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "client" 
                              ? context.state.SwitchCivilite 
                              : (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "conjoint"
                                ? context.state.SwitchCiviliteConjoint
                                : context.state.Civilite
                          )}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                            <h4 style={{
                              margin: 0,
                              fontSize: "14px",
                              fontWeight: "600",
                              color: "#1f2937"
                            }}>
                              {(context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "client" 
                                ? `${context.state.SwitchCivilite || context.state.Civilite} ${context.state.Nom} ${context.state.Prenom}`
                                : (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "conjoint"
                                  ? `${context.state.SwitchCiviliteConjoint || context.state.CiviliteConjoint} ${context.state.NomConjoint} ${context.state.PrenomConjoint}`
                                  : `${context.state.Civilite} ${context.state.Nom} ${context.state.Prenom}`
                              }
                            </h4>
                          </div>
                          <div style={{ display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" }}>
                            <FaCalendarAlt style={{  color: "#6b7280" }} />
                            <span style={{  color: "#6b7280" }}>
                              {(context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "client" 
                                ? `${handleNe(context.state.SwitchCivilite || context.state.Civilite)} le ${applyFormat(context.state.DateNaissance, "date")}`
                                : (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "conjoint"
                                  ? `${handleNe(context.state.SwitchCiviliteConjoint || context.state.CiviliteConjoint)} le ${applyFormat(context.state.DateNaissanceConjoint, "date")}`
                                  : `${handleNe(context.state.Civilite)} le ${applyFormat(context.state.DateNaissance, "date")}`
                              }
                            </span>
                          </div>
                          {(context.state.StatutMarital === "marie" || context.state.StatutMarital === "pacse") && (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <FaHeart style={{ color: "#ef4444" }} />
                              <span style={{  color: "#6b7280" }}>
                                {(context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "client" 
                                  ? `${handleSituationMaritale(context.state.SwitchCivilite || context.state.Civilite, context.state.StatutMarital)} à ${context.state.NomConjoint} ${context.state.PrenomConjoint}, ${handleNe(context.state.CiviliteConjoint)} le ${applyFormat(context.state.DateNaissanceConjoint, "date")}`
                                  : (context.state.TypeSimulation === "Audit prévoyance" || context.state.TypeSimulation === "Audit rémunération") && context.state.SwitchClient === "conjoint"
                                    ? `${handleSituationMaritale(context.state.SwitchCiviliteConjoint || context.state.CiviliteConjoint, context.state.StatutMarital)} à ${context.state.Nom} ${context.state.Prenom}, ${handleNe(context.state.Civilite)} le ${applyFormat(context.state.DateNaissance, "date")}`
                                    : `${handleSituationMaritale(context.state.Civilite, context.state.StatutMarital)} à ${context.state.NomConjoint} ${context.state.PrenomConjoint}, ${handleNe(context.state.CiviliteConjoint)} le ${applyFormat(context.state.DateNaissanceConjoint, "date")}`
                                }
                              </span>
                            </div>
                          )}
                          {context.state.Isole === true && (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <FaUser style={{ fontSize: "12px", color: "#f59e0b" }} />
                              <span style={{  color: "#6b7280" }}>Parent isolé</span>
                            </div>
                          )}
                          {context.state.TableauEnfant && context.state.TableauEnfant.length > 0 && (
                            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                              <FaBaby style={{ fontSize: "12px", color: "#10b981" }} />
                              <span style={{  color: "#6b7280" }}>
                                {context.state.TableauEnfant.length} enfant{context.state.TableauEnfant.length > 1 ? 's' : ''}
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                      {context.state.ApiUser !== true && (
                        <Button
                          onClick={() => {
                            setmodalOpen(true);
                          }}
                          icon
                          {...createStyledButton("card-action", "cardEdit")}
                        >
                          <FaEdit style={{ color: "#22c55e", fontSize: "12px" }} />
                        </Button>
                      )}
                    </div>
                  </div>
                </Row>
                {/* Parts fiscales */}
                <Row tpad>
                  <div style={{
                    backgroundColor: "white",
                    border: "1px solid #e5e7eb",
                    borderRadius: "12px",
                    padding: "16px",
                    width: "100%",
                    minHeight: "96px",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
                    marginBottom: "12px"
                  }}>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <div style={{
                          width: "48px",
                          height: "48px",
                          borderRadius: "50%",
                          backgroundColor: "#dbeafe",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}>
                          <FaCalculator style={{ fontSize: "14px", color: "#3b82f6" }} />
                        </div>
                        <div>
                          <div style={{ fontSize: "14px", fontWeight: "600", color: "#1f2937", marginBottom: "2px" }}>
                            Parts fiscales
                          </div>
                          <div style={{ fontSize: "12px", color: "#6b7280" }}>
                            {context.state.SetPartFiscale === false ? "Calculé automatiquement" : "Saisi manuellement"}
                          </div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <Button 
                          tabIndex="-1" 
                          icon 
                          onClick={() => context.handleValueChange("SetPartFiscale", false)}
                          {...createStyledButton("card-action", "cardEdit",{backgroundColor:"#dbeafe"})}
                        >
                          {context.state.SetPartFiscale === false ? 
                            <FaCalculator style={{ color: "#3b82f6", fontSize: "12px" }} /> : 
                            <FaSync style={{ color: "#3b82f6", fontSize: "12px" }} />
                          }
                        </Button>
                        <TextField
                          value={context.state.PartFiscale}
                          onChange={(e) => {
                            context.handleValueChange("SetPartFiscale", true);
                            context.handleValueChange("PartFiscale", Math.max(1, e.target.value));
                          }}
                          dataType="ufloat"
                          format={{ thousands: " ", precision: 2, decimal: "," }}
                          small
                          style={{ minWidth: "80px" }}
                        />
                      </div>
                    </div>
                  </div>
                </Row>
              </Column>
            </CardBox>
          </Column>
        </Row>
      </Column>
      <Modal
        width="80%"
        height="80%"
        title="Fiche client"
        icon={<FaGlobe />}
        visible={modalOpen}
        onClose={() => {
          setmodalOpen(false);
        }}
      >
        <ClientPageModal
          visible={modalOpen}
          onClose={() => {
            setmodalOpen(false);
          }}
        />
      </Modal>
    </>
  );
};

export default DossierPage;
